import { defineMessages } from 'react-intl';

export default defineMessages({
	addAction: {
		defaultMessage: 'Add "{value}"',
		description: 'Action shown to users when they have the option to add a option',
		id: 'cv.multi.user.picker.add.action',
	},
});
